export const titleStyles = {
  fontWeight: 600,
  fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
  marginBottom: { xs: '0.15rem', sm: '0.2rem' }
};

export const LabelStyle = {
  fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
  marginBottom: { xs: '0.1rem', sm: '0.15rem' },
  fontWeight: 500
};

export const TextFieldStyle = {
  marginBottom: { xs: '0.15rem', sm: '0.2rem' },
  width: '100%',
  '& .MuiInputBase-root': {
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
    minHeight: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
    height: { xs: '1.5rem', sm: '1.75rem', md: '2rem' }
  },
  '& .MuiInputBase-input': {
    padding: { xs: '0.4rem 0.5rem', sm: '0.5rem 0.6rem', md: '0.6rem 0.75rem' },
    height: 'auto !important'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#e0e0e0'
    },
    '&:hover fieldset': {
      borderColor: '#1976d2'
    }
  }
};

export const selectStyle = {
  fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
  height: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
  width: '100%',
  '& .MuiSelect-select': {
    padding: { xs: '0.4rem 0.5rem', sm: '0.5rem 0.6rem', md: '0.6rem 0.75rem' },
    height: 'auto !important',
    display: 'flex',
    alignItems: 'center'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#e0e0e0'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1976d2'
  }
};

export const sectionHeaderStyles = (
  backgroundColor: string,
  borderColor: string,
  textColor: string
) => ({
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 0.5, sm: 0.75, md: 1 },
  mb: { xs: 1, sm: 1.25, md: 1.5 },
  pl: { xs: 0.5, sm: 0.75, md: 1 },
  pr: { xs: 0.5, sm: 0.75 },
  borderBottom: `1px solid ${borderColor}`,
  pb: { xs: 0.5, sm: 0.75, md: 1 }
});

export const sectionTitleBoxStyles = (
  backgroundColor: string,
  borderColor: string
) => ({
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 0.3, sm: 0.5, md: 0.75 },
  backgroundColor,
  px: { xs: 0.75, sm: 1, md: 1.25 },
  py: { xs: 0.25, sm: 0.375, md: 0.5 },
  borderRadius: { xs: '3px', sm: '4px', md: '5px' },
  border: `1px solid ${borderColor}`,
  minHeight: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' }
});

export const errorTextStyles = {
  pl: { xs: 0.5, sm: 0.75, md: 1 },
  pr: { xs: 0.5, sm: 0.75, md: 1 },
  fontSize: { xs: '0.6rem', sm: '0.65rem', md: '0.7rem' },
  lineHeight: { xs: 1.1, sm: 1.2, md: 1.3 },
  mt: 0.25
};

// Responsive grid spacing
export const gridSpacingStyles = {
  spacing: { xs: 0.75, sm: 1, md: 1.5 }
};

// Section icon styles
export const sectionIconStyles = {
  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' }
};

// Section title typography
export const sectionTitleStyles = {
  fontWeight: 600,
  fontSize: { xs: '0.85rem', sm: '1rem', md: '1.1rem' },
  letterSpacing: '0.3px'
};

// Phone number field specific styles
export const phoneFieldStyles = {
  '& .MuiInputBase-root': {
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
    height: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
    '& input': {
      padding: {
        xs: '0.4rem 0.5rem',
        sm: '0.5rem 0.6rem',
        md: '0.6rem 0.75rem'
      }
    }
  }
};

// Multiline text field styles
export const multilineTextFieldStyles = {
  ...TextFieldStyle,
  '& .MuiInputBase-root': {
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
    minHeight: 'auto',
    height: 'auto'
  },
  '& .MuiInputBase-input': {
    padding: { xs: '0.5rem', sm: '0.6rem', md: '0.75rem' }
  }
};

// Autocomplete styles
// ...existing code...

export const autocompleteStyles = {
  '& .MuiInputBase-root': {
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
    minHeight: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
    height: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
    padding: '0 !important'
  },
  '& .MuiInputBase-input': {
    padding:
      { xs: '0.4rem 0.5rem', sm: '0.5rem 0.6rem', md: '0.6rem 0.75rem' } +
      ' !important'
  },
  '& .MuiAutocomplete-endAdornment': {
    right: { xs: '6px', sm: '8px', md: '10px' },
    top: '50%',
    transform: 'translateY(-50%)',
    height: 'auto',
    '& .MuiAutocomplete-clearIndicator': {
      padding: { xs: '2px', sm: '3px', md: '4px' },
      margin: 0,
      '& .MuiSvgIcon-root': {
        fontSize: { xs: '16px', sm: '18px', md: '20px' }
      }
    },
    '& .MuiAutocomplete-popupIndicator': {
      padding: { xs: '2px', sm: '3px', md: '4px' },
      margin: 0,
      '& .MuiSvgIcon-root': {
        fontSize: { xs: '16px', sm: '18px', md: '20px' }
      }
    }
  }
};

export const dialogStyles = {
  '& .MuiDialog-paper': {
    margin: { xs: '8px', sm: '16px', md: '24px' },
    maxHeight: {
      xs: 'calc(100vh - 16px)',
      sm: 'calc(100vh - 32px)',
      md: 'calc(100vh - 48px)'
    },
    width: {
      xs: 'calc(100vw - 16px)',
      sm: 'calc(100vw - 48px)', // Enhanced from 64px
      md: '920px', // Enhanced from 750px
      lg: '1000px' // Added large screen support
    },
    maxWidth: {
      xs: '100%',
      sm: '95%', // Enhanced from 90%
      md: '920px',
      lg: '1000px'
    }
  }
};

// Dialog content styles
export const dialogContentStyles = {
  padding: { xs: '8px 12px', sm: '12px 16px', md: '16px 20px' } // Enhanced padding
};

export const dialogActionsStyles = {
  padding: { xs: '6px 10px', sm: '8px 12px', md: '12px 16px' },
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'stretch', sm: 'center' },
  justifyContent: 'flex-end',
  gap: { xs: 0.75, sm: 1 }
};

export const formContainerStyles = {
  width: '100%',
  maxWidth: '100%',
  mx: 'auto',
  px: { xs: 0.5, sm: 1, md: 1.5 },
  py: { xs: 0.5, sm: 1, md: 1.5 }
};

export const buttonStyles = {
  fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
  padding: { xs: '6px 12px', sm: '8px 16px', md: '10px 20px' },
  minHeight: { xs: '32px', sm: '36px', md: '40px' },
  width: { xs: '100%', sm: 'auto' }
};

export const multiSelectAutocompleteStyles = {
  '& .MuiInputBase-root': {
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
    minHeight: { xs: '2.5rem', sm: '3rem', md: '3.5rem' }, // Increased height for tags
    height: 'auto', // Allow dynamic height
    padding: { xs: '4px', sm: '6px', md: '8px' },
    maxHeight: { xs: '4rem', sm: '5rem', md: '6rem' }, // Max height with scroll
    overflowY: 'auto'
  },
  '& .MuiInputBase-input': {
    padding: { xs: '2px 4px', sm: '4px 6px', md: '6px 8px' } + ' !important',
    minWidth: '120px' // Ensure input has minimum width
  },
  '& .MuiAutocomplete-tag': {
    margin: { xs: '1px', sm: '2px', md: '2px' },
    height: { xs: '20px', sm: '22px', md: '24px' },
    fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.75rem' },
    maxWidth: '150px', // Limit tag width
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '120px'
    }
  },
  '& .MuiAutocomplete-tagList': {
    display: 'flex',
    flexWrap: 'wrap',
    gap: { xs: '2px', sm: '4px', md: '4px' },
    maxHeight: { xs: '3rem', sm: '4rem', md: '5rem' },
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '2px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '2px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8'
    }
  },
  '& .MuiAutocomplete-endAdornment': {
    right: { xs: '4px', sm: '6px', md: '8px' },
    top: { xs: '4px', sm: '6px', md: '8px' },
    position: 'absolute'
  },
  '& .MuiAutocomplete-inputRoot': {
    paddingRight: '40px !important' // Space for dropdown arrow
  }
};

export const customChipStyles = {
  height: { xs: '18px', sm: '20px', md: '22px' },
  fontSize: { xs: '0.6rem', sm: '0.65rem', md: '0.7rem' },
  fontWeight: 500,
  borderRadius: { xs: '9px', sm: '10px', md: '11px' },
  backgroundColor: '#e3f2fd',
  color: '#1565c0',
  border: '1px solid #90caf9',
  '& .MuiChip-label': {
    padding: { xs: '0 4px', sm: '0 6px', md: '0 8px' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: { xs: '80px', sm: '100px', md: '120px' }
  },
  '& .MuiChip-deleteIcon': {
    fontSize: { xs: '14px', sm: '16px', md: '18px' },
    color: '#1565c0',
    '&:hover': {
      color: '#d32f2f'
    }
  },
  '&:hover': {
    backgroundColor: '#bbdefb'
  }
};

export const dynamicMultiSelectStyles = {
  '& .MuiInputBase-root': {
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
    minHeight: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
    height: 'auto', // Dynamic height based on content
    padding: { xs: '6px', sm: '8px', md: '10px' },
    paddingRight: '40px !important', // Space for dropdown arrow
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    gap: { xs: '4px', sm: '6px', md: '8px' }
  },
  '& .MuiInputBase-input': {
    padding: '0 !important',
    minWidth: '120px',
    flex: 1,
    order: 999 // Input field comes last
  },
  '& .MuiAutocomplete-tag': {
    margin: 0,
    height: { xs: '22px', sm: '24px', md: '26px' },
    fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.75rem' },
    maxWidth: 'calc(100% - 40px)', // Account for dropdown arrow
    order: 1 // Tags come first
  },
  '& .MuiAutocomplete-endAdornment': {
    position: 'absolute',
    right: { xs: '8px', sm: '10px', md: '12px' },
    top: { xs: '8px', sm: '10px', md: '12px' }
  }
};

export const visibleChipStyles = {
  height: { xs: '22px', sm: '24px', md: '26px' },
  fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.75rem' },
  fontWeight: 500,
  borderRadius: { xs: '11px', sm: '12px', md: '13px' },
  maxWidth: '100%',
  '& .MuiChip-label': {
    padding: { xs: '0 6px', sm: '0 8px', md: '0 10px' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  '& .MuiChip-deleteIcon': {
    fontSize: { xs: '16px', sm: '18px', md: '20px' },
    marginRight: '2px',
    '&:hover': {
      color: '#d32f2f'
    }
  }
};
